import { EngineeringUnit } from 'journeys/portal/Forms/Sections.constants';
import { paddingLabel } from '../C11/C11.data';
import { labelWidth } from '../P710/P710.data';

export const HMISectionDataP621 = (selectedTag, formData) => {
    const switchSetpointCommentCondition = formData?.F798SwitchSetpointComment ?? selectedTag?.SwitchSetpointComment;
    const borderBottomLDisable = switchSetpointCommentCondition ? '' : 0;
    return {
        rows: [
            {
                key: 1,
                fields: [
                    {
                        key: 'F1051SpeedSensorTypeLabel',
                        label: 'Speed Sensor Type',
                        xs: 3,
                        isLabel: true,
                        fontWeight: '600',
                        fontSize: '9pt',
                        padding: '4px 0 0 0',
                        marginTop: '15px'
                    },
                    {
                        key: 'F1051SpeedSensorType',
                        value: formData.F1051SpeedSensorType,
                        isDropdown: true,
                        placeholder: 'Select Sensor Type',
                        options: [{ name: 'Select Sensor Type', value: '' },
                        { name: 'Electronic', value: 'Electronic' },
                        { name: 'Magnetic', value: 'Magnetic' },
                        { name: 'Proximity', value: 'Proximity' }],
                        labelWidth: '0%',
                        isRequired: true,
                        width: '100%',
                        height: '1.6rem',
                        inputTextAlign: 'center',
                        paddingRightPlaceholder: '15px',
                        marginTop: '15px',
                        xs: 2,
                    },
                    {
                        key: 'F1052BuiltTripSetpointLabel',
                        label: 'As-Built Trip Setpoint',
                        xs: 5,
                        isLabel: true,
                        fontWeight: '600',
                        labelWidth,
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel,
                        marginTop: '15px'
                    },
                    {
                        key: 'F1052BuiltTripSetpoint',
                        value: selectedTag.DateTested ? formData?.F1052BuiltTripSetpoint : formData?.F1052BuiltTripSetpoint ?? selectedTag?.SwitchSetpoint,
                        xs: 2,
                        direction: 'rtl',
                        width: '100%',
                        labelWidth: '0%',
                        marginRight: '0',
                        textAlign: 'center',
                        maxLength: '10',
                        marginTop: '15px',
                        borderBottom: borderBottomLDisable,
                        height: '1.3rem',
                        isRequired: true,
                        type: 'number',
                    },
                ]
            },
            switchSetpointCommentCondition ? {
                key: 2,
                fields: [
                    {
                        key: 'Nodata',
                        isLabel: true,
                        xs: 5,
                    },
                    {
                        key: 'F798SwitchSetpointCommentLabel',
                        label: 'Setpoint Comment',
                        xs: 5,
                        textAlign: 'right',
                        fontStyle: 'italic',
                        padding: '5px 0 0 6px',
                        isLabel: 'true',
                        labelWidth: '97%',
                        fontSize: '9pt',
                        fontWeight: '600'
                    },
                    {
                        key: 'F798SwitchSetpointComment',
                        value: selectedTag?.DateTested ? formData?.F798SwitchSetpointComment : switchSetpointCommentCondition,
                        textAlign: 'center',
                        fontStyle: 'italic',
                        isInfo: true,
                        wordBreak: false,
                        width: '100%',
                        height: '1.2rem',
                        padding: '5px 0 0 5px',
                        labelWidth: '0',
                        noWrap: true
                    }]
            } : {
                key: 3,
                fields: []
            },
            {
                key: 2,
                fields: [
                    {
                        key: 'F1053SensorResistanceLabel',
                        label: 'Sensor Resistance (Ω)',
                        xs: 3,
                        isLabel: true,
                        fontWeight: '600',
                        fontSize: '9pt',
                        padding: paddingLabel
                    },
                    {
                        key: 'F1053SensorResistance',
                        value: formData?.F1053SensorResistance,
                        xs: 2,
                        width: '100%',
                        labelWidth: '0%',
                        textAlign: 'center',
                        marginRight: '0',
                        type: 'number',
                        maxLength: '10',
                        marginBottom: '15px',
                        height: '1.3rem',
                        borderTop: borderBottomLDisable,
                    },
                    {
                        key: 'F28InstrumentEngineeringUnitLabel',
                        label: EngineeringUnit.ENGINEERING_UNIT_EU,
                        xs: 5,
                        isLabel: true,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        labelWidth,
                        padding: paddingLabel,
                    },
                    {
                        key: 'F28InstrumentEngineeringUnit',
                        value: selectedTag.DateTested ? formData?.F28InstrumentEngineeringUnit : formData?.F28InstrumentEngineeringUnit ?? selectedTag?.TsprInstrumentEngineeringUnits,
                        xs: 2,
                        direction: 'rtl',
                        inputWidth: '100%',
                        labelWidth: '0%',
                        marginRight: '0',
                        textAlign: 'center',
                        maxLength: '17',
                        isAutoGrow: true,
                        marginTop: '0',
                        isRequired: true
                    }]
            },
        ]
    };
};
